<template>
  <div class="cc-button" @click="onClick">
    <div v-if="largerStyle" class="cc-button-click-larger" :style="largerStyle"></div>
    <div class="text">{{ reservationText }}</div>
  </div>
</template>
<script>
import qs from 'qs'
import {
  MINI_live_button_click,
  MINI_live_reservation_click,
  MINI_live_up_reservation_click,
  MINI_live_reservation_success,
  MINI_live_up_reservation_success,
  MINI_live_button_error
} from '../constants/reportEvents'
import { callJSB } from '../utils'
import { getPlatform, isHarmonyOS } from '../../utils/device'
const spmid = '999.0.0.live'

export default {
  name: 'CcLiveButton',
  components: {},
  inject: ['compName', 'compId'],
  props: {
    isAuto: {
      type: Boolean,
      default: false
    },
    isClient: {
      type: Boolean,
      default: false
    },
    reservationId: {
      type: [Number, String],
      default: ''
    },
    event: {
      type: Object,
      default: () => ({
        title: '',
        desc: '',
        stime: '',
        is_follow: 0,
        can_follow: 1
      })
    }
  },
  data() {
    return {
      largerStyle: {},
      platform: '',
      loading: false
    }
  },
  computed: {
    reservationText() {
      return +this.event.is_follow === 0 ? '预约' : '已预约'
    }
  },
  created() {},
  mounted() {
    this.getBtnStyle()
    this.platform = getPlatform()
  },
  methods: {
    clientReport(id, reserve) {
      if (this.isClient) {
        callJSB({
          method: 'cm.onLiveReservePageReserveResult',
          data: {
            reserve_id: id,
            reserve_result: reserve
          }
        })
      }
    },
    getBtnStyle() {
      setTimeout(() => {
        if (window._globalExp?.web_cvr_up && window._globalExp?.button_click_larger?.is_open) {
          this.largerStyle =
            window._globalExp?.button_click_larger?.type === 'scale'
              ? {
                  transform: `scale(${window._globalExp?.button_click_larger.scale})`
                }
              : {
                  left: `${window._globalExp?.button_click_larger.padding}`,
                  right: `${window._globalExp?.button_click_larger.padding}`,
                  top: `${window._globalExp?.button_click_larger.padding}`,
                  bottom: `${window._globalExp?.button_click_larger.padding}`
                }
        }
      }, 1000)
    },
    onClick() {
      if (isHarmonyOS()) {
        this.$toast('鸿蒙设备暂不支持应用下载及预约')
        return
      }
      this.$reportUI(MINI_live_button_click)
      // window?.alita?.appInfo?.mid

      if ((!window?.alita?.appInfo?.mid && !this.reservationId) || +this.event.can_follow === 0) {
        this.$reportUI(MINI_live_button_error)
        this.$toast('预约失败')
        return
      }
      if (this.loading) {
        return
      }
      if (+this.event.is_follow === 0) {
        this.$reportUI(MINI_live_reservation_click)
        this.loading = true
        this.$request
          .post(
            'v1/landing_pages/add/reserve',
            {
              sid: this.reservationId,
              mid: window?.alita?.appInfo?.mid,
              // mid: '2337612997853577',
              spmid: spmid
            },
            {
              checkStatus: false
            }
          )
          .then(({ code = 200 }) => {
            // 主播接口未返回状态码，此处所以用中文判断成功态
            if (+code === 0) {
              this.clientReport(this.reservationId, 1)
              this.$reportUI(MINI_live_reservation_success)
              this.$toast('预约成功')
              this.event.is_follow = 1
            } else {
              this.clientReport(this.reservationId, 0)
              this.$toast('预约失败')
            }
            this.loading = false
          })
          .catch(() => {
            this.clientReport(this.reservationId, 0)
            this.loading = false
            this.$toast('预约失败')
          })
      }
      if (+this.event.is_follow === 1) {
        this.$reportUI(MINI_live_up_reservation_click)
        this.loading = true
        // 主播接口未返回状态码，此处所以用中文判断成功态
        this.$request
          .post(
            'v1/landing_pages/del/reserve',
            {
              sid: this.reservationId,
              mid: window?.alita?.appInfo?.mid,
              // mid: '2337612997853577',
              spmid: spmid
            },
            {
              checkStatus: false
            }
          )
          .then(({ code = 200 }) => {
            if (+code === 0) {
              this.$reportUI(MINI_live_up_reservation_success)
              this.$toast('取消预约成功')
              this.event.is_follow = 0
            } else {
              this.$toast('取消预约失败')
            }
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            this.$toast('预约失败')
          })
      }
    },
    withTrackId(url) {
      const search = (window.location.search || '')
        .substr(1)
        .replace('track_id=__TRACKID__', 'track_id=')
      if (!url) {
        return url
      }
      if (search === '') {
        return url
      }

      const query = qs.parse(search) || {}
      const trackId = query.track_id || ''

      if (!trackId) return url

      // 有宏，则将宏无脑替换成实际trackId
      if (url?.includes('__TRACKID__')) {
        return url.replace('__TRACKID__', trackId)
      }

      return url
    }
  }
}
</script>
<style lang="less" scoped>
.cc-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  line-height: 1;
  box-sizing: border-box;
  text-align: center;
  border-style: solid;
  position: relative;
  & .text {
    width: 90%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.cc-button-click-larger {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
